<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main><router-view/></main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>

export default {
name: 'App',    
    metaInfo() {
        return { 
            title: "Magicom - AI solutions in one stop",
            meta: [
                { name: 'description', content:  'Magicom is an AI-as-a-service (AaaS) service company, providing full-stack intellegence services and solutions ranging from data process(collection, clean, augmentation and annotation), model development(training and deployment) and enterprise applications.'},
                { property: 'og:title', content: "Magicom - AI solutions in one stop"},
                { property: 'og:site_name', content: 'Magicom'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>
